import React from "react";

const Button = ({
  bg,
  onClick,
  width,
  borderRadius,
  label,
  color,
  px,
  py,
  border,
  startIcon,
  endIcon,
}) => {
  return (
    <button
      className={`btn w-${width} px-${px} py-${py} d-flex align-items-center gap-2 justify-content-center`}
      onClick={onClick}
      style={{
        backgroundColor: `${bg}`,
        color: `${color}`,
        border: `${border}`,
        borderRadius: `${borderRadius} `,
      }}
    >
      {startIcon && startIcon}
      {label}
      {endIcon && endIcon}
    </button>
  );
};

export default Button;
